export default "__VITE_ASSET__EFgmcs7i__"